import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery} from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get, post, del } from "@utils/axios_api";

const fetchLectureList = async (params) => {
  const response = await get("/lecture/list", {params});
  return response;
};
const fetchCategoryList = async () => {
  const response = await get("/common/categoryList");
  return response;
};
export function useLectureList() {
  const [searchParams, setSearchParams] = useSearchParams();

  const methods = useForm({
    defaultValues: {
      eduCategoryId: "",
      eduType: searchParams.get('eduType') || 'B',
      searchWrd: "",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });
  
  const eduCategoryId = searchParams.get("eduCategoryId") || "";
  const eduType = searchParams.get("eduType") || "";
  const searchWrd = searchParams.get("searchWrd") || "";
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;

  const queryParam = {
    eduCategoryId, eduType, searchWrd,
    pageIndex, recordCountPerPage,
  };

  const { data:lectureList, refetch } = useQuery({
    queryKey: ["selectUserLectureList", JSON.stringify(queryParam)],
    queryFn: () => fetchLectureList(queryParam),
    keepPreviousData: true,
  });

  const { data:categoryList } = useQuery({
    queryKey: ["selectUserCategoryList"],
    queryFn: () => fetchCategoryList(),
    staleTime: Infinity,
  });


  const refreshList = () => {
    refetch();
  };

  const onSubmit = (values) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("eduCategoryId", values.eduCategoryId || "");
    newParams.set("eduType", values.eduType || "B");
    newParams.set("searchWrd", values.searchWrd || "");
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };


  return {
    methods, lectureList, categoryList,
    onSubmit, handlePageChange,
    pageIndex, recordCountPerPage,
    refreshList
  };



}
